import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import Button from "../components/Button";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import { apiRequest, assetUrl, formatPrice } from "../api/client";
import { useCart } from "../context/CartContext";
import { useToast } from "../context/ToastContext";
import fallbackCover from "../assets/Ebook.png";

export default function ProductPage() {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const cart = useCart();
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    apiRequest(`/api/products/${slug}`)
      .then((response) => setProduct(response.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <section className="section"><LoadingSpinner label="Loading product" /></section>;
  if (error) return <section className="section"><div className="container"><p className="form-status error">{error}</p></div></section>;

  return (
    <section className="section detail-hero product-page">
      <div className="container ebook-detail-grid">
        <motion.div className="ebook-showcase" initial={{ opacity: 0, x: -24 }} animate={{ opacity: 1, x: 0 }}>
          <div className="product-image-frame">
            <img src={assetUrl(product.image_url, fallbackCover)} alt={product.name} />
          </div>
        </motion.div>
        <motion.div className="detail-copy ebook-detail-copy" initial={{ opacity: 0, x: 24 }} animate={{ opacity: 1, x: 0 }}>
          <span className="eyebrow">{product.category}</span>
          <h1>{product.name}</h1>
          <p>{product.description}</p>
          <div className="price-row detail-price">
            {product.discount_price && <s>{formatPrice(product.price)}</s>}
            <span>{formatPrice(product.discount_price || product.price)}</span>
          </div>
          <div className="hero-pills">
            <span>Digital download</span>
            <span>{product.stock_type === "unlimited" ? "Unlimited access" : `${product.stock_quantity || 0} left`}</span>
            <span>{product.status}</span>
          </div>
          <div className="ebook-actions">
            <Button onClick={() => {
              cart.add(product);
              toast?.show("Added to cart.");
              navigate("/checkout");
            }}>Buy Now</Button>
            <Button variant="secondary" onClick={() => {
              cart.add(product);
              toast?.show("Added to cart.");
            }}>Add to Cart</Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
